import React from 'react';
import { useTranslation } from 'react-i18next';

import * as S from './ConditionSection.styles';

export interface ConditionSectionProps {
  condition: string;
}

export const ConditionSection = ({ condition }: ConditionSectionProps) => {
  const { t } = useTranslation(['scenarioCommander']);
  return (
    <S.Root data-testid="condition-section">
      <S.TitleLabel>{t('scenarioCommander:whatHasHappened')}</S.TitleLabel>
      <S.ConditionLabel>{condition}</S.ConditionLabel>
    </S.Root>
  );
};
